import type { PaletteOptions } from "@mui/material/styles";
import * as C from "@/constants/colors";

export const lightPalette: PaletteOptions = {
  mode: "light",
  common: { black: C.BLACK, white: C.WHITE },
  primary: {
    light: C.LIGHT_PRIMARY_LIGHT,
    main: C.LIGHT_PRIMARY_MAIN,
    dark: C.LIGHT_PRIMARY_DARK,
    contrastText: C.LIGHT_PRIMARY_CONTRAST,
  },
  secondary: {
    light: C.LIGHT_SECONDARY_LIGHT,
    main: C.LIGHT_SECONDARY_MAIN,
    dark: C.LIGHT_SECONDARY_DARK,
    contrastText: C.LIGHT_SECONDARY_CONTRAST,
  },
  info: C.INFO,
  success: C.SUCCESS,
  warning: C.WARNING,
  error: C.ERROR,
  grey: C.LIGHT_GREY,
  divider: C.LIGHT_DIVIDER,
  text: {
    primary: C.LIGHT_TEXT_PRIMARY,
    secondary: C.LIGHT_TEXT_SECONDARY,
    disabled: C.LIGHT_TEXT_DISABLED,
  },
  background: { paper: C.LIGHT_BG_PAPER, default: C.LIGHT_BG_DEFAULT },
  action: {
    active: C.LIGHT_TEXT_PRIMARY,
    hover: C.LIGHT_ACTION_HOVER,
    selected: C.LIGHT_ACTION_SELECTED,
    disabled: C.LIGHT_ACTION_DISABLED,
    disabledBackground: C.LIGHT_ACTION_DISABLED_BG,
    focus: C.LIGHT_ACTION_SELECTED,
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export const darkPalette: PaletteOptions = {
  mode: "dark",
  common: { black: C.BLACK, white: "#BDBDBD" },
  primary: {
    light: C.DARK_PRIMARY_LIGHT,
    main: C.DARK_PRIMARY_MAIN,
    dark: C.DARK_PRIMARY_DARK,
    contrastText: C.DARK_PRIMARY_CONTRAST,
  },
  secondary: {
    light: C.DARK_SECONDARY_LIGHT,
    main: C.DARK_SECONDARY_MAIN,
    dark: C.DARK_SECONDARY_DARK,
    contrastText: C.DARK_SECONDARY_CONTRAST,
  },
  info: C.DARK_INFO,
  success: C.DARK_SUCCESS,
  warning: C.DARK_WARNING,
  error: C.DARK_ERROR,
  grey: C.DARK_GREY,
  divider: C.DARK_DIVIDER,
  text: {
    primary: C.DARK_TEXT_PRIMARY,
    secondary: C.DARK_TEXT_SECONDARY,
    disabled: C.DARK_TEXT_DISABLED,
  },
  background: { paper: C.DARK_BG_PAPER, default: C.DARK_BG_DEFAULT },
  action: {
    active: C.DARK_TEXT_PRIMARY,
    hover: C.DARK_ACTION_HOVER,
    selected: C.DARK_ACTION_HOVER,
    disabled: C.DARK_ACTION_DISABLED,
    disabledBackground: C.DARK_ACTION_DISABLED_BG,
    focus: C.DARK_ACTION_FOCUS,
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};
